import { getLocationData } from 'actions/location';
import { getAttractions } from 'actions/attraction';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel.js';

export default store => ({
	path: 'directions',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'Location',
			),
		onEnter: ({ params: { lang, hotel } }) => {
			store.dispatch(getLocationData(lang, hotel));
			store.dispatch(getAttractions(lang, hotel));
			store.dispatch(getBanner(lang, hotel, 'location'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'directions'));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Location/index.js